import React from "react";
import { Link, LinkProps } from "react-router-dom";

import * as style from "./NavigationLinkStyle.module.scss"

type Props = {
  label: React.ReactNode;
} & LinkProps;

const NavigationLink = ({ label, ...props }: Props) => (
  <Link {...props} className={style.navigationLink}>
    {label}
  </Link>
);

export default NavigationLink;
